(function($) {
    //Global
    var current_view = 'pc'; //Viewport State
    var ww = $(window).width(); //Window Width
    var wh = $(window).height(); //Window Height
    var user_scroll = $(window).scrollTop(); //Scroll Position

    /////////////////////////////////////////////
    /* Init */
    /////////////////////////////////////////////
    $(document).ready(function(){
        ww = $(window).width();
        wh = $(window).height();
        user_scroll = $(window).scrollTop();
        
        setTimeout(function(){
            $(window).resize();
            checkViewsizeAndOverflow();
            checkAnimation();
            $('body').addClass('show');
            $('header').addClass('show');
        }, 100);
        
        setTimeout(function(){
            $('.visual').addClass('active');
            if($('body#index').length){
                document.getElementById('kv').play();
                var video_visual = $('#kv').get(0);
                setTimeout(function(){
                    video_visual.muted = true;
                    video_visual.playsinline = true;
                    video_visual.play();
                }, 100);
            }
            $('.fixedbnr').addClass('active');
        }, 300);    

        setTimeout(function(){
            $('.visualscroll').addClass('activeend');
        }, 3000);   
        
        $('header .bt_menu').off('click').on('click', function(e){
            e.stopPropagation();
            $('header').toggleClass('open');
            $('header .gmenu').fadeToggle(300);
        });

        if($('body#index').length){     
            $('#index main .sec.case .bt_more2').on('click', function(){
                $(this).remove();
                $('#index main .sec.case .postlist li').show();
            });
            $('#index main .sec.report .bt_more2').on('click', function(){
                $(this).remove();
                $('#index main .sec.report .postlist li').show();
            });
        }

        if(!$('body#index .sec.seminar .postlist li').length){
            $('body#index .sec.seminar .postlist').addClass('nopost').append('<li class="trimbox scrollactive">現在、お申込み受付中のセミナーはありません</li>')
        }
        
        if(ww >= 768){
            
        } else {
            setTimeout(function(){
                $('#index .sec.topics h2').addClass('active');
            }, 600);    
        }
    });


    /////////////////////////////////////////////
    /* Resizing */
    /////////////////////////////////////////////
    $(window).resize(function(){
        ww = $(window).width();
        wh = $(window).height();
        
        var past_view = current_view;
        checkViewsizeAndOverflow();
        checkAnimation();
        
        if(ww >= 768){
            
        } else {
            
        }
    });

    /////////////////////////////////////////////
    /* Scrolling */
    /////////////////////////////////////////////
    $(window).scroll(function (){
        checkAnimation();
    });

    function checkAnimation(){
        user_scroll = $(window).scrollTop();    

        /* INDEX PAGE LOGIC */
        if($('body#index').length){
            $('main .visual .bg').css('top', user_scroll*0.3+'px');
            if(user_scroll > $('footer').offset().top - wh) {
                $('.fixedbnr').addClass('hide');
            } else {
                $('.fixedbnr').removeClass('hide');
            }
            
            if(user_scroll > $('main .intro').offset().top - wh*0.3) {
                $('.tri').addClass('active');
                $('.tri2').addClass('active');
            } else {
                $('.tri').removeClass('active');
                $('.tri2').removeClass('active');
            }
            if(user_scroll > $('main .bgwrap').offset().top) {
                $('#index .bgwrap .bg').show();
            } else {
                $('#index .bgwrap .bg').hide();
            }
            if(user_scroll > $('main .bgwrap2').offset().top - wh*0.5) {
                $('#index .bgwrap').addClass('hide');
                $('#index .tri2').addClass('hide');
                $('#index .tri').addClass('bg2');
            } else {
                $('#index .bgwrap').removeClass('hide');
                $('#index .tri2').removeClass('hide');
                $('#index .tri').removeClass('bg2');
            }
            if(user_scroll > $('main .bgwrap3').offset().top - wh*0.5) {
                $('#index .content').addClass('bg3');
                $('#index .tri').addClass('bg3');
            } else {
                $('#index .content').removeClass('bg3');
                $('#index .tri').removeClass('bg3');
            }
            if(user_scroll > $('main .bgwrap4').offset().top - wh*0.5) {
                $('#index .content').addClass('bg4');
                $('#index .tri').addClass('bg4');
            } else {
                $('#index .content').removeClass('bg4');
                $('#index .tri').removeClass('bg4');
            }
            if(ww >= 768){
                if(user_scroll > $('main .intro').offset().top) {
                    $('#index .bgwrap .bg').css('background-position', 'left 50% bottom -'+((ww*0.4) + ($('main .intro').offset().top - user_scroll)*0.8)+'px');
                } else {
                    $('#index .bgwrap .bg').css('background-position', 'left 50% bottom -'+(ww*0.4)+'px');
                }
            } else {
                if(user_scroll > $('main .intro').offset().top - 100) {
                    $('#index .bgwrap .bg').css('background-position', 'left 50% bottom -'+((ww*0.6) + ($('main .intro').offset().top + 0 - user_scroll)*0.5)+'px');
                } else {
                    $('#index .bgwrap .bg').css('background-position', 'left 50% bottom -'+(ww*0.6)+'px');
                }
            }
        }

        /* ABOUT PAGE LOGIC */
        if($('body#inner.about').length){
            if(user_scroll > $('main .intro').offset().top - wh*0.3) {
                $('.tri').addClass('active');
                $('.tri2').addClass('active');
            } else {
                $('.tri').removeClass('active');
                $('.tri2').removeClass('active');
            }
            if(user_scroll > $('main .bgwrap2').offset().top - wh*0.5) {
                $('header').addClass('dark');
                $('main .bgwrap').addClass('hide');
                $('main .tri2').addClass('hide');
                $('main .tri').addClass('hide');
            } else {
                $('header').removeClass('dark');
                $('main .bgwrap').removeClass('hide');
                $('main .tri2').removeClass('hide');
                $('main .tri').removeClass('hide');
            }
            if(ww >= 768){
                if(user_scroll > $('main .intro').offset().top) {
                    $('main .bgwrap .bg').css('background-position', 'left 50% bottom -'+((ww*0.4) + ($('main .intro').offset().top - user_scroll)*0.8)+'px');
                } else {
                    $('main .bgwrap .bg').css('background-position', 'left 50% bottom -'+(ww*0.4)+'px');
                }
            } else {
                if(user_scroll > $('main .intro').offset().top - 500) {
                    $('main .bgwrap .bg').css('background-position', 'left 50% bottom -'+((ww*0.6) + ($('main .intro').offset().top + 300 - user_scroll)*0.5)+'px');
                } else {
                    $('main .bgwrap .bg').css('background-position', 'left 50% bottom -'+(ww*0.6)+'px');
                }
            }
        }

        /* INNER SINGLE COLUMN LOGIC */
        if($('body#inner.single.column').length){

            let $connection = $('body.single.column main .column-details_content__inner.connection');

            if ($connection.length) {
                if(user_scroll > $connection.offset().top - wh*0.5) {
                    $('header').removeClass('dark');
                } else {
                    $('header').addClass('dark');
                }
            }

            let $contact = $('body.single.column .contact_common');
            if ($contact.length) {
                if(user_scroll > $contact.offset().top - wh) {
                    $('.fltbtn').fadeOut(300);
                } else {
                    $('.fltbtn').fadeIn(300);
                }
            }
        }
        
        /* COMMON SCROLL LOGIC */
        var offset = 300;
        if(ww >= 768){
            if(user_scroll > 0) {
                $('.visualscroll').addClass('scroll');
            }
            if(user_scroll > 200) {
                $('.visualscroll .newsbox').addClass('fixedend');
            } else {
                $('.visualscroll .newsbox').removeClass('fixedend');
            }
        } else {
            offset = 150;
            if(user_scroll > 0) {
                $('.visualscroll').addClass('scroll');
            }
        }

        if(user_scroll > ww * 0.5) {
            $('.bt_gototop').fadeIn(300);
        } else {
            $('.bt_gototop').fadeOut(300);
        }
        $('.scrollactive').each(function(){scrollActive($(this), offset);});
    }

    /////////////////////////////////////////////
    /* Other Functions */
    /////////////////////////////////////////////
    $(function(){
       $('a[rel*=anchor]').click(function() {
          var speed = 600;
          var href= $(this).attr("href");
          var target = $(href == "#" || href == "" ? 'html' : href);
          var position = target.offset().top;
              var offset = 80;
                if(ww >= 768){
                }
                else {
                    offset = 74;
                }
                if(href == '#intro') offset += 90;
                if(href == '#unit_detail') offset -= 90;
                if(href == '#case') offset -= 90;
          $('body,html').animate({scrollTop:(position-offset)}, speed, 'swing');
          return false;
       });
    });

    // 目次（TOC+）の開閉アニメーション
    // $(function(){
    //     $('#toc_toggle_link').on('click', function(e) {
    //         e.preventDefault(); 
            
    //         var $link = $(this);
            
    //         $('#toc_list').slideToggle(400, function() {
                
    //             if ($(this).is(':visible')) {
    //                 $link.text('hide');
    //             } else {
    //                 $link.text('show');
    //             }
    //         });
    //     });
    // });


    function scrollActive(seelctor, offset) {
        user_scroll = $(window).scrollTop();
        
        if($(seelctor).length) {
            if(user_scroll > $(seelctor).offset().top - wh + offset) {
                $(seelctor).addClass('active');
                setTimeout(function(){
                    $(seelctor).addClass('show');
                }, 600);
            }
        }
    }

    function checkViewsizeAndOverflow() {
        if(ww >= 768){
            $("body").addClass("pc_view").removeClass("sp_view");
            current_view = 'pc';
        } else {
            $("body").addClass("sp_view").removeClass("pc_view");
            current_view = 'sp';
        }   
        if(wh >= 500){
            $("body").removeClass("overflow_menu");
        } else {
            $("body").addClass("overflow_menu");
        }
    }

})(jQuery);